<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { KkLoading, KkIcon } from '../../../components/base'
import { KkInfo } from '../../../components/ui'
const store = useStore()
const { company_uuid } = useRoute().params
const snsCategories = computed(() => store.state.companiesSnsCategories.data)
const snsCategoriesLoading = computed(() => store.state.companiesSnsCategories.loading)
const snsCategoryLoading = computed(() => store.state.companiesSnsCategory.loading)
const readSnsCategories = () => store.dispatch('companiesSnsCategories/readSnsCategories')
const deleteSnsCategory = (snsCategoryId) => store.dispatch('companiesSnsCategory/deleteSnsCategory', snsCategoryId)
const handleDelete = async (snsCategoryId) => {
  await deleteSnsCategory(snsCategoryId)
  readSnsCategories()
}
const load = () => {
  readSnsCategories()
}
load()
</script>
<template>
  <div>
    <div class="p-box">
      <KkLoading v-if="snsCategoriesLoading || snsCategoryLoading" />
      <div v-else class="p-box__body">
        <KkInfo class="infoContainer">
          <!-- Todo 文言がfixしたら変更する必要あり -->
          {{ $t('pages.companies.management.snsCategories.info') }}
        </KkInfo>
        <p v-if="snsCategories.length === 0">
          {{ $t('messages.notRegistered', { value: $t('models.snsCategory.modelName') }) }}
        </p>
        <div v-else>
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th><span>{{ $t('models.snsCategory.modelName') }}</span></th>
                  <th />
                </tr>
                <tr class="p-table__content__space"><td colspan="5" /></tr>
              </thead>
              <tbody>
                <tr v-for="snsCategory in snsCategories" :key="snsCategory.id">
                  <td class="u-fwB">{{ snsCategory.name }}</td>
                  <td>
                    <div class="flexContainer">
                      <router-link class="action" :to="{ name: 'CompaniesSnsCategoryEdit', params: { company_uuid: company_uuid, sns_category_id: snsCategory.id }}">
                        <KkIcon name="edit" color="rgba(58, 59, 63, 0.7)" class="action__icon" />
                        {{ $t('labels.edit') }}
                      </router-link>
                      <a class="action" @click="handleDelete(snsCategory.id)">
                        <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" class="action__icon" />
                        {{ $t('labels.delete') }}
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesSnsCategoryNew', params: { company_uuid: company_uuid }, query: { currentTab: 'SnsCategory' } }" class="c-button__item c-button__item--primary">{{ $t('labels.add', { value: $t('models.snsCategory.modelName') }) }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.flexContainer {
  display: flex;
  justify-content: flex-end;
}
.editButton {
  text-decoration: none;
}
.infoContainer {
  margin-bottom: 15px;
}
.p-table__content tbody th:not(:first-child), .p-table__content tbody td:not(:first-child) {
  border-left: none;
}
.action {
  display: flex;
  align-items: flex-start;
  margin-right: 24px;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  &__icon {
    width: 18px;
    margin-right: 8px;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
